import { action } from 'typesafe-actions';
import {
  Types,
  ILongSteelShoppingCartState,
  ILongSteelOrderItem
} from './types';

export const loadLongSteelShoppingCartFromLocalStorage = () =>
  action(Types.LOAD_FROM_LOCAL_STORAGE);
export const updateLongSteelShoppingCartSettings = (
  longSteelShoppingCartState: ILongSteelShoppingCartState
) =>
  action(Types.UPDATE_SHOPPING_CART_SETTINGS, { longSteelShoppingCartState });

export const finishOrder = (
  items: ILongSteelOrderItem[],
  emitterId: string,
  receiverId: string,
  customerOrder: string
) =>
  action(Types.FINISH_ORDER, { items, emitterId, receiverId, customerOrder });
export const finishOrderSuccess = (createdOrders: string[]) =>
  action(Types.FINISH_ORDER_SUCCESS, { createdOrders });
export const finishOrderFailure = (error: unknown) =>
  action(Types.FINISH_ORDER_FAILURE, { error });

export const cleanShoppingCart = () =>
  action(Types.CLEAN_SHOPPING_CART, {
    items: [],
    emitterId: '',
    receiverId: '',
    customerOrder: ''
  });

export const setTypeOfOrder = (typeOfOrder: string) =>
  action(Types.UPDATE_TYPE_OF_ORDER, { typeOfOrder });

export const setTaggingInfoPreviousScreen = ({
  screenName,
  itemDescription
}: {
  screenName: string;
  itemDescription: string;
}) =>
  action(Types.UPDATE_TAGGING_INFO_PREVIOUS_SCREEN, {
    screenName,
    itemDescription
  });
